@import 'styles/mixins';
@import 'styles/blaze/mixins';

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  padding: 10px 20px 10px 14px;
  background-color: var(--light-100);
  border-bottom: 1px solid var(--dark-4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}

.left {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  max-width: calc(var(--chat-width, 0px) + (100vw - var(--chat-width, 0px) - var(--sidebar-width, 0px)) / 2 - 220px);
}

.iconButtons {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}

.titleGroup {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  height: 32px;
}

.title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 0 1 280px;

  @media (max-width: $inch15Width) {
    flex-basis: 180px;
  }

  @media (max-width: $responsiveMedium) {
    flex-basis: 120px;
  }
}

.statusPill {
  flex-shrink: 0;
}

.centerNav {
  position: absolute;
  left: calc(var(--chat-width, 0px) + (100vw - var(--chat-width, 0px) - var(--sidebar-width, 0px)) / 2);
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 6px;

  &.hasActions {
    gap: 20px;
  }
}

.approvalActions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.approveButton {
  background: var(--green);
  border-color: var(--green);

  &:hover {
    background: var(--green-70);
  }
}

.approvedPill {
  display: flex;
  align-items: center;
}

.right {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}

.generatingPill {
  display: flex;
  align-items: center;
}

.header {
  :global(.ant-skeleton) {
    display: flex !important;
    align-items: center !important;
  }

  :global(.ant-skeleton-header) {
    display: flex !important;
    padding-right: 4px !important;
    align-items: center;
  }

  :global(.ant-skeleton-title) {
    margin-top: 0 !important;
    align-items: center;
    border-radius: 4px;
    width: 280px !important;

    @media (max-width: $inch15Width) {
      width: 180px !important;
    }

    @media (max-width: $responsiveMedium) {
      width: 120px !important;
    }
  }
}
